import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AjustageConductivite } from 'src/app/domain/Shared/ajustage-conductivite';
import { AjustageContexte } from 'src/app/domain/Shared/ajustage-context';
import { AjustagePH } from 'src/app/domain/Shared/ajustage-pH';
import { ControleConductiviteGroup } from 'src/app/domain/Shared/controle-conductivite-groupe';
import { ControlePH } from 'src/app/domain/Shared/controle-pH';
import { ControlePHGroup } from 'src/app/domain/Shared/controle-pH-groupe';
import { EConductivite } from 'src/app/domain/Shared/enum/conductivite';
import { EpH } from 'src/app/domain/Shared/enum/pH';
import { MasterSondeService } from 'src/app/services/master-sonde.service';
import { CoreData } from '../../core-data';

@Component({
    selector: 'app-pH-calibration-box',
    templateUrl: './pH-calibration-box.component.html',
    styleUrls: ['./pH-calibration-box.component.scss']
})
export class PHCalibrationBoxComponent implements OnInit {

    model: AjustageContexte = new AjustageContexte()
    group: ControlePHGroup = new ControlePHGroup()

    PH4: AjustagePH = new AjustagePH()
    PH7: AjustagePH = new AjustagePH()
    PH10: AjustagePH = new AjustagePH()

    public interventionTime;
    private sondeRef: string

    CanEditAjustage: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<PHCalibrationBoxComponent>,
        private sondeService: MasterSondeService,
        private coreData: CoreData,
        @Inject(MAT_DIALOG_DATA) public data) {
        if (data) {
            this.sondeRef = data;
        }

    }

    IsMobile() {
        return this.coreData.IsMobile;
    }

    ngOnInit(): void {
        this.group.PH2.Type = EpH.pH2
        this.group.PH7.Type = EpH.pH7010
        this.group.PH12.Type = EpH.pH12

        this.getSondeDetails(this.sondeRef)
    }

    timeSet(event: string) {
        const time = event.split(':');

        this.model.Date = new Date(this.model.Date);
        this.model.Date.setHours(Number(time[0]), Number(time[1]));
        this.setTime();
    }

    setTime() {
        this.interventionTime = `${this.model.Date.getHours()}:${this.model.Date.getMinutes()}`;
    }

    copyPente() {
        this.PH4.Pente = this.PH10.Pente = this.PH7.Pente
        console.log(this.PH4.Pente)
        console.log(this.PH10.Pente)
    }

    copyDecalage() {
        this.PH4.Decalage = this.PH10.Decalage = this.PH7.Decalage
        console.log(this.PH4.Decalage)
        console.log(this.PH10.Decalage)
    }

    // <mat-error align="end">Valeur entre -66 et -56</mat-error>
    // <mat-error align="end">Valeur entre -12 et +12 </mat-error>
    CanAddNewMeasure() {
        return this.CanEditAjustage ?
            this.model.Date &&
            this.PH4.NumeroLot && this.PH4.Decalage !== null && this.PH4.Pente !== null &&
            this.PH7.NumeroLot && this.PH7.Decalage !== null && this.PH7.Pente !== null &&
            this.PH10.NumeroLot && this.PH10.Decalage !== null && this.PH10.Pente !== null &&
            this.PH4.NumeroLot !== this.PH4.ControlePh.ControleNumeroLot &&
            this.PH7.NumeroLot !== this.PH7.ControlePh.ControleNumeroLot &&
            this.PH10.NumeroLot !== this.PH10.ControlePh.ControleNumeroLot &&
            this.PH4.ControlePh.ControleNumeroLot && this.PH4.ControlePh.Temperature !== null && this.PH4.ControlePh.ValeurCible !== null && this.PH4.ControlePh.ValeurLue !== null &&
            this.PH7.ControlePh.ControleNumeroLot && this.PH7.ControlePh.Temperature !== null && this.PH7.ControlePh.ValeurCible !== null && this.PH7.ControlePh.ValeurLue !== null &&
            this.PH10.ControlePh.ControleNumeroLot && this.PH10.ControlePh.Temperature !== null && this.PH10.ControlePh.ValeurCible !== null && this.PH10.ControlePh.ValeurLue !== null
            :
            this.group.Date &&
            // this.group.PH2.Temperature && this.group.PH2.ValeurCible && this.group.PH2.ValeurLue && this.group.PH2.ControleNumeroLot &&
            this.group.PH7.Temperature && this.group.PH7.ValeurCible && this.group.PH7.ValeurLue && this.group.PH7.ControleNumeroLot 
            // this.group.PH12.Temperature && this.group.PH12.ValeurCible && this.group.PH12.ValeurLue && this.group.PH12.ControleNumeroLot
    }

    getSondeDetails(ref: string) {
        this.sondeService.getSondeByReference(ref).subscribe(x => {
            this.model = x.AjustageContexteList[0] ?? new AjustageContexte();

            if (x.AjustageContexteList[0]?.Code)
                this.CanEditAjustage = false;

            this.PH4 = this.model.AjustagePhList.find(x => x.ControlePh.Type === EpH.pH4) ?? new AjustagePH()
            this.PH7 = this.model.AjustagePhList.find(x => x.ControlePh.Type === EpH.pH7005) ?? new AjustagePH()
            this.PH10 = this.model.AjustagePhList.find(x => x.ControlePh.Type === EpH.pH10) ?? new AjustagePH()
            this.PH4.ControlePh.Type = EpH.pH4
            this.PH7.ControlePh.Type = EpH.pH7005
            this.PH10.ControlePh.Type = EpH.pH10

        })
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.model.ControlePhGroupeList.push(this.group)

        this.model.AjustagePhList = []
        this.model.AjustagePhList.push(this.PH4, this.PH7, this.PH10)

        this.dialogRef.close(this.model);
    }
}
